import { render, staticRenderFns } from "./CardIntro.vue?vue&type=template&id=54686c48&"
import script from "./CardIntro.vue?vue&type=script&lang=js&"
export * from "./CardIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports